<template>
  <div class="skuList">
      <el-dialog
        title="SKU列表"
        :visible.sync="dialogVisible"
        width="960px"
        :close-on-click-modal="false"
      >
          <div  v-loading="tableDataLoading"
          element-loading-text="SKU列表拼命加载中"
          element-loading-spinner="el-icon-loading">
              <el-table :data="tableData" style="width: 100%" height="550">
                  <el-table-column label="序号" align="left" type=index width="50">
                  </el-table-column>
                  <el-table-column prop="skuname" label="SKU信息" >
                    <template slot-scope="scope">
                      <div>{{scope.row.skuname}}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="标价">
                    <template slot-scope="scope" v-if="scope.row.skuprice">
                      ¥{{scope.row.skuprice}}
                    </template>
                  </el-table-column>
                  <el-table-column label="到手价">
                    <template slot-scope="scope" v-if="scope.row.availableprice">
                      ¥{{scope.row.availableprice}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" label="状态" width="80">
                    <template slot-scope="scope">
                      <div v-if="scope.row.skuislowprice" style="background-color: red;width: 20px;height: 20px;color: white;text-align: center;line-height: 20px;border-radius: 20px;">
                        低
                      </div>
                      <img :src='require("@/assets/img/other/zhiwen-status.png")' alt="" class="zhiwen_status" v-show="scope.row.ischange=='是'">
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" label="产品" width="200">
                    <template slot-scope="scope">
                      <div class="productname">
                        <span v-if="scope.row.productid">
                          <span v-if="scope.row.productid.length > 20">
                            {{scope.row.productname}}
                          </span>
                          <span v-else>
                            限价标准：¥{{scope.row.productid}}
                          </span>
                        </span>
                        <el-popover placement="top-start" width="200" trigger="click" v-show="priceData">
                          <div>
                            <div v-for="item in $options.filters.objToAr(priceData)" :key="item.name">
                              <div>{{item.name}}:{{item.val}}</div>
                            </div>
                          </div>
                          <i class="el-icon-warning-outline" slot="reference" @click="getInfoByProductIds(scope.row)" v-show="scope.row.productname"></i>
                        </el-popover>
                      </div>
                    </template >
                  </el-table-column>
              </el-table>
          </div>
      </el-dialog>
  </div>

</template>

<script>
    import aes from '@/libs/aes'
    export default {
        name: "newSkuList",
        data:function(){
          return{
            priceData: {},
            tableDataLoading:false,
            tableDataAll:[],
            dialogVisible:false,
            tableData:[],
            paginae:{
                currentPage:1,
                pageSizes:[10, 20, 30, 40],
                total:40
            }
          }
        },
        methods:{
          getInfoByProductIds(row) {
      			let params={
              id: row.productid,
            }
            fetch({
              url: "hcm/hcmProduct/getInfoByProductIds",
              method: "get",
              params: params,
              noFormat: true,
              responseType: "text"
            }).then(result => {
              let res = JSON.parse(result);
              let {data}=res
              if(res.status == '10000'){
      					console.log(data)
      					if (data && data[0].price) {
      		        this.priceData = data[0].price
      		      }
              } else {
                this.$message({
                  message: res.message,
                  type: "error"
                });
              }
            }).catch(err => {
      				this.$message.error('服务器出错');
      			})
      		},
          open(data) {
            this.dialogVisible = true
            this.tableData = data
          },
          dialogVisibleShow(){
            this.dialogVisible=!this.dialogVisible
          }
        },
        filters: {
            bjBigSmall:aes.bjBigSmall,
            objToAr:aes.objToArr
        },
    }
</script>

<style lang="scss">
    $ts:#faad14;
    $blue:#409EFF;
    .test_low_price{
        .popper__arrow:after {
            border-bottom-color: $ts!important;
        }
        .popper__arrow {
            border-bottom-color: $ts!important;
        }
        .el-tooltip__popper.is-dark{
            background: $ts;
        }
    }
    .skuList{
        .skuname{
            color: $blue;
        }
        .bottom_page .el-pagination{
            padding: 20px 0 0 0;
        }
        .el-dialog{
            height: 680px;
        }
        .el-table--fit{
            height: 530px;
            overflow-y: auto;
            width: 100%;
        }
        .zhiwen_status{
            width: 20px;
            height: 20px;
        }
    }

</style>
